import { ApiGroup } from '../types/ApiTypes';

export const AdViewLogAPI: ApiGroup = {
    pagedList: {
        title: '광고 노출 로그 조회',
        method: 'POST',
        url: '/AdViewLog/PagedList',
        paramz: {},
    },
};
